/**
 * `true` when the `window` is fully contained within any slot's
 * interval. Used by the click reducer to swallow no-op clicks that
 * land inside an existing pick — without this, every single click
 * on an already-scheduled cell produces a duplicate.
 *
 * Inclusive bounds on both sides: a click at exactly `slot.start`
 * or ending at exactly `slot.end` still counts as "inside".
 */
import type { SelfSlot } from '../types';
import { toMs } from './toMs';

export function fullyCoveredBy(
  window: { startMs: number; endMs: number },
  slots: SelfSlot[],
  timezone: string
): boolean {
  for (const slot of slots) {
    const pStart = toMs(slot.start, timezone);
    const pEnd = toMs(slot.end, timezone);
    if (pStart <= window.startMs && pEnd >= window.endMs) return true;
  }
  return false;
}
